import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CURRENCY } from '../../../config/appConfig';
import { AppRoutes } from '../../../constants/appRoutes';
import { MarketplaceStatuses } from '../../../constants/marketplaceStatuses';
import { currencyFormatterHelper } from '../../../helpers/currencyFormatterHelper';
import { buildLocalizeRoute } from '../../../helpers/languageHelper';
import { ButtonWrapper } from '../../../shared/components/formUtilities/useButton';
import { TextWrapper } from '../../../shared/components/formUtilities/useTextWrapper';
import { MarketplaceService } from '../views/marketplace/marketplaceService';

export const LatestOpportunities = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [opportunities, setOpportunities] = useState([]);

	useEffect(() => {
		const marketplaceService = new MarketplaceService();
		marketplaceService
			.getMarketplace()
			.then((resp) => {
				const active = resp.data?.filter((item) => item?.showInMarketPlace) || [];
				setOpportunities(active.slice(0, 2));
			})
			.catch(() => {});
	}, []);

	const handleInvest = (opp) => {
		navigate(
			buildLocalizeRoute(
				`${AppRoutes.Investor}/${AppRoutes.Marketplace}/${AppRoutes.MarketplaceBusinessDetails}/${opp.id}?status=${MarketplaceStatuses.Current}`
			)
		);
	};

	return (
		<Box className="rounded-2xl p-6 h-full bg-investor-bg">
			<TextWrapper
				classList="!font-bold !text-[16px] !text-investor-mint !mb-3"
				text={t('latestOpportunities')}
			/>
			<hr className="border-t border-investor-divider mb-4" />

			{!opportunities.length ? (
			<Box className="flex flex-col items-center justify-center h-full py-8 gap-2">
				<TextWrapper classList="!text-sm !text-investor-mint !text-center" text={t('noOpportunitiesAvailable')} />
				<ButtonWrapper
					onClick={() => navigate(buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.Marketplace}`))}
					label={<span>{t('viewMarketplace').toUpperCase()}</span>}
					classList="!bg-investor-green !text-white !rounded-full !px-5 !h-[32px] !text-xs !min-w-0"
				/>
			</Box>
		) : opportunities.map((opp, idx) => {
				const pct = opp.campaignAmount
					? Math.round((opp.investedAmount / opp.campaignAmount) * 100)
					: 0;

				return (
					<Box key={opp.id}>
					<TextWrapper
						classList="!text-[14px] !font-semibold !truncate !block !max-w-full !text-investor-green"
						text={opp.businessName}
					/>

						<Box className="flex items-center justify-between mt-2">
							<Box>
							<Box className="text-[13px] text-investor-mint">
								{t('requested')}{' '}
								<span className="font-bold text-investor-mint">
									{CURRENCY} {currencyFormatterHelper(opp.campaignAmount, 0)}
								</span>
							</Box>
							<Box className="text-[13px] text-investor-mint mt-0.5">
								{t('funded')}{' '}
								<span className="font-bold text-investor-mint">
									{CURRENCY} {currencyFormatterHelper(opp.investedAmount, 0)}
								</span>
							</Box>
								<ButtonWrapper
									onClick={() => handleInvest(opp)}
									label={<span>{t('invest').toUpperCase()}</span>}
							classList="!bg-investor-green !text-white !rounded-full !px-5 !h-[32px] !text-xs !mt-2 !min-w-0"
								/>
							</Box>

							<Box className="relative flex items-center justify-center flex-shrink-0 w-[80px] h-[80px]">
							<CircularProgress
								variant="determinate"
								value={100}
								size={80}
								thickness={4}
								sx={{ color: '#96ECE0', position: 'absolute' }}
							/>
							<CircularProgress
								variant="determinate"
								value={pct}
								size={80}
								thickness={4}
								sx={{ color: '#00D175' }}
							/>
								<Box className="absolute text-white text-xs font-bold">{pct}%</Box>
							</Box>
						</Box>

						{idx < opportunities.length - 1 && (
							<hr className="border-t border-investor-divider my-4" />
						)}
					</Box>
				);
			})}
		</Box>
	);
};
